import { LocalConversationId, LocalConversationModel } from '@deal/chat-firebase-client';

/**
 * Get the guest conversation message sequence for the provided expert ID, and kick off
 *   execution of that sequence.
 *
 * This method must be idempotent. It is called repeatedly when the conversation,
 *   recipients, or chat client state changes.
 */

function startGuestConversation(startGuestConversationMutationFn, conversation, recipientIds) {
  // Only start the conversation if it is a local conversation
  var isLocalConversation = conversation && LocalConversationId.isLocalConversationId(conversation.conversationId); // Assume the first recipient is the expert

  var expertId = recipientIds && recipientIds[0]; // Start the guest conversation

  if (conversation && isLocalConversation && conversation instanceof LocalConversationModel && expertId) {
    startGuestConversationMutationFn({
      variables: {
        input: {
          expertId: expertId
        }
      }
    }).then(function (result) {
      if (result && result.data && result.data.startGuestConversation) {
        var _a = result.data.startGuestConversation.conversation,
            messages = _a.messages,
            signature = _a.signature;
        var sequence = {
          messages: messages.map(function (gqlMessage) {
            return {
              id: gqlMessage.id,
              parts: gqlMessage.parts.map(function (gqlPart) {
                return {
                  type: gqlPart.type,
                  body: JSON.parse(gqlPart.body)
                };
              }),
              typeAt: gqlMessage.typeAt,
              sendAt: gqlMessage.sendAt,
              sendBy: gqlMessage.sendBy.id
            };
          }),
          signature: signature
        };
        conversation.startMessageSequence(sequence);
      }
    });
  }
}

export default startGuestConversation;
//# sourceMappingURL=startGuestConversation.js.map
